import DemandStudio from '../../../components/demand-studio/DemandStudio';

const DemandStudioPage = () => <DemandStudio />;

export default DemandStudioPage;
